module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "reservations"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Breakfasts\n\n            "), _c('small', {
    staticClass: "controls"
  }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, 'DD MMMM \'YY')) + " \n\n                "), _c('span', {
    staticClass: "pe-7s-angle-left-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" \n                "), _c('span', {
    staticClass: "pe-7s-angle-right-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'DD MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('print'), _vm._v(" \n            ")], 1)])]), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.reservations.length) + " room(s) / " + _vm._s(_vm.eatingGuests) + " guests")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('router-link', {
      key: reservation.id,
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'reservations.view',
          params: {
            id: reservation.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(reservation.room.title)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(reservation.name))]), _vm._v(" / " + _vm._s(reservation.numberOfBreakfasts) + " guest(s)\n\n                "), _c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action hidden-print"
    })])
  }), 1)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b9ef66c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/breakfasts/Breakfasts.vue
// module id = 406
// module chunks = 1